import React from 'react';
export const VEXU_LOGO = 'https://cdn.magicpatterns.com/uploads/3A8d459aXLumR8KKFCQtrD/vexu_logo.svg';
export const ZAIN_LOGO = 'https://cdn.magicpatterns.com/uploads/v6desCRNT7CwM3FSbyjh7P/ZainBlackLogo.svg';
export function VexuMark({
  size = 40
}: {
  size?: number;
}) {
  return <img src={VEXU_LOGO} alt="" aria-hidden="true" style={{
    width: size,
    height: size
  }} className="object-contain" data-id="element-444" data-mp="m6ogjvcv1k5x" />;
}
interface VexuLockupProps {
  size?: number;
  wordmarkSize?: number;
  className?: string;
}
export function VexuLockup({
  size = 34,
  wordmarkSize = 22,
  className = ''
}: VexuLockupProps) {
  return <span className={`inline-flex items-center gap-[10px] ${className}`} data-id="element-445" data-mp="88qd3l02v857">
      <VexuMark size={size} data-id="element-446" data-mp="3f5fhu2ecg6j" />
      <span style={{
      fontSize: wordmarkSize
    }} className="font-semibold tracking-[-0.02em] text-slate-900" data-id="element-447" data-mp="3duchwgrzcgh">
        Vexu.ai
      </span>
    </span>;
}

/** Official Zain black wordmark, used unmodified on the light canvas. */
export function ZainMark({
  height = 30
}: {
  height?: number;
}) {
  return <img src={ZAIN_LOGO} alt="Zain" style={{
    height
  }} className="object-contain" data-id="element-448" data-mp="b4b8opqcijjr" />;
}
interface PartnershipLockupProps {
  vexuSize?: number;
  vexuWordmarkSize?: number;
  zainHeight?: number;
  gap?: number;
}
export function PartnershipLockup({
  vexuSize = 30,
  vexuWordmarkSize = 19,
  zainHeight = 26,
  gap = 26
}: PartnershipLockupProps) {
  return <div className="inline-flex items-center" style={{
    gap
  }} data-id="element-449" data-mp="3ob335xi70h0w">
      <VexuLockup size={vexuSize} wordmarkSize={vexuWordmarkSize} data-id="element-450" data-mp="3obcwnv2g56bc" />
      <span className="text-slate-300" style={{
      fontSize: vexuWordmarkSize * 0.85
    }} data-id="element-451" data-mp="3sbn2n7q8nwq7">
        ×
      </span>
      <ZainMark height={zainHeight} data-id="element-452" data-mp="17oom35ufwis" />
    </div>;
}